






import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class PLabel extends Vue {
    @Prop() type: string | undefined;
}
